import Typography from '../../library/Typography';
import { HeadingProps } from './index';
import { styled } from '@mui/material/styles';

const styledHeadingOptions = {
  shouldForwardProp: (prop: string) => !['isUppercase'].includes(prop),
};

export const StyledHeading = styled(
  Typography,
  styledHeadingOptions,
)<HeadingProps>((props) => {
  const { isUppercase, gutterBottom } = props;

  return {
    textTransform: isUppercase ? 'uppercase' : 'initial',
    ...(gutterBottom && {
      marginBottom: '12px',
    }),
  };
});
